import { useEffect, useState } from "react";
import type { ReferenceMaterialMode } from "@verity/database/prisma";
import type { CoreFileItem } from "@verity/components/core";
import { getReferenceMaterials } from "./proctoringResultViewHelper";

type UseReferenceMaterialControlProps = {
	referenceMaterialMode: ReferenceMaterialMode | undefined;
	sessionUuid: string;
};

export default function useReferenceMaterialControl({
	referenceMaterialMode,
	sessionUuid,
}: UseReferenceMaterialControlProps) {
	const [files, setFiles] = useState<CoreFileItem[]>([]);
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		if (!referenceMaterialMode || referenceMaterialMode === "off") {
			setFiles([]);
			return;
		}

		let cancelled = false;
		setLoading(true);

		getReferenceMaterials(sessionUuid)
			.then((result) => {
				if (!cancelled) setFiles(result);
			})
			.catch((error) => {
				console.error(error);
				if (!cancelled) setFiles([]);
			})
			.finally(() => {
				if (!cancelled) setLoading(false);
			});

		return () => {
			cancelled = true;
		};
	}, [referenceMaterialMode, sessionUuid]);

	return {
		mode: referenceMaterialMode,
		files,
		loading,
	};
}

export type UseReferenceMaterialControlReturn = ReturnType<typeof useReferenceMaterialControl>;
